import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  TextField,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import * as Yup from "yup";
import LGModal from "../LGModal";
import { addExpenseAccount } from "../../api/accounting";
import { addProviderActivity } from "../../api/providers";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const validationSchema = Yup.object({
  name: Yup.string()
    .required("El nombre es requerido")
    .max(255, "El nombre no puede exceder 255 caracteres"),
  contpaqiCode: Yup.string()
    .required("El no. de cuenta contable es requerido")
    .max(50, "El código no puede exceder 50 caracteres"),
});

const AddExpenseAccountModal = ({ open, handleClose, companyId, providerId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { openSnack } = useSnack();

  const initialValues = {
    name: "",
    contpaqiCode: "",
  };

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        companyId: companyId,
      };

      const response = await addExpenseAccount(payload);
      
      if (response.status === 201) {
        // If a provider is selected, register the expense account as a provider activity
        if (providerId) {
          try {
            const providerActivityPayload = {
              providerId: providerId,
              expenseAccountId: response.data.id,
            };
            console.log(providerActivityPayload);
            await addProviderActivity(providerActivityPayload);
            openSnack("Cuenta contable creada y registrada como actividad del proveedor exitosamente", "success");
          } catch (providerError) {
            // If provider activity creation fails, still show success for expense account
            openSnack("Cuenta contable creada, pero ocurrió un error al registrar la actividad del proveedor", "warning");
            console.error("Error creating provider activity:", providerError);
          }
        } else {
          openSnack("Cuenta contable creada exitosamente", "success");
        }
        
        resetForm();
        handleClose();
        if (onSuccess) {
          onSuccess(response.data);
        }
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LGModal
      open={open}
      handleClose={handleClose}
      header="Agregar Cuenta Contable"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <Stack spacing={3}>
              <Field name="name">
                {({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Nombre de la cuenta"
                    variant="outlined"
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    disabled={loading}
                  />
                )}
              </Field>

              <Field name="contpaqiCode">
                {({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="No. de cuenta contable"
                    variant="outlined"
                    error={touched.contpaqiCode && Boolean(errors.contpaqiCode)}
                    helperText={touched.contpaqiCode && errors.contpaqiCode}
                    disabled={loading}
                  />
                )}
              </Field>

              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading || isSubmitting}
                  startIcon={loading && <CircularProgress size={20} />}
                >
                  {loading ? "Guardando..." : "Guardar"}
                </Button>
              </Stack>
            </Stack>
          </Form>
        )}
      </Formik>
    </LGModal>
  );
};

export default AddExpenseAccountModal;
